/* RESPONSIBLE TEAM: team-self-serve */
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';

export default class UpdateSubscriptionRoute extends Route {
  @service declare router: RouterService;
  @service declare intl: IntlService;

  get titleToken() {
    return this.intl.t(`new-settings.submenu.workspace.billing.update-subscription`);
  }

  redirect(): any {
    return this.router.transitionTo('apps.app.settings.subscription.billing.update-subscription');
  }
}
